export default [
  {
    title: 'FONCTIONNEMENT GÉNÉRAL',
    slug: 'fontionnement-general',
    preview: 'Quel est le principe de Wiltee ?',
    text: `
### Quel est le principe de Wiltee ?

Wiltee a deux métiers :

#### WILTEE POD.

À l’intérieur de Wiltee POD ( Print On Demand) il y a également deux façons de fonctionner.

+ __Vous créez une boutique directement sur wiltee.com.__

__Avantages :__
Vous avez une boutique en ligne et êtes prêt à vendre en 2 minutes top chrono.
Vous n’avez aucun investissement financier à réaliser.
Vous pouvez uploader un logo et une image de couverture.

Exemple de boutique : https://made-in-alsace.wiltee.com.

__Inconvénients :__
Vous disposez d’un template de boutique unique où il n’est pas possible de changer les couleurs.


+ __Vous utilisez Wiltee en tant qu’application à relier à votre site Shopify.__

__Avantages :__
Vous bénéficiez de la crème de la crème du print on demand français 100% automatisé
Vous disposez de toute la puissance qu’offre un CMS tel que Shopify : site sur mesure, plugins dédiés

__Inconvénients :__
Un petit investissement financier, minimum 30 dollars d’abonnement mensuel aux services de Shopify.


#### WILTEE B to B.

Notre cœur de métier est la personnalisation textile. Nous sommes capables aussi bien d’imprimer à la demande que d’imprimer en quantité. Notre clientèle est multi-sectorielle : restauration, hôtellerie, clubs et associations, startups, marques de mode … Nous disposons de toutes les techniques de marquage en interne: impression numérique, flex, sérigraphie, broderie. Vous souhaitez un devis ? Vous avez une commande à passer ? Envoyez un email à : bruno@wiltee.com on vous répondra sous 24-48h ! 

### Devons-nous acheter des stocks de produits ?

Et non, c’est le principe même du Print On Demand qui signifie littéralement Impression à la demande donc à l’unité donc pas de stock à acheter. Magique. 


### Comment créer un code promo sur ma boutique Wiltee ? 

Pour créer un code promo sur Wiltee, vous devez avoir créé une boutique au préalable.
Une fois votre boutique créée, allez dans “boutique” puis “éditer la boutique” puis “coupons” puis “créer un coupon”.
    `
  },
  {
    title: 'MARQUAGES DISPONIBLES',
    slug: 'marquages-disponibles',
    text: `
### La broderie est-elle possible à la demande ? 

Non ! Mais ce ne serait tarder. Nous prévoyons un investissement au 1er trimestre 2021. En attendant, nous prenons vos commandes en broderie seulement à partir de 12 pièces, 


### Quels sont nos différents types d’impression à la demande ? 

L’impression numérique (qu’on appelle aussi DTG en anglaus, direct to garment)
La flexographie

### Wiltee s’occupe-t-il des impressions en interne ou sous-traite-t-il ?

Wiltee dispose de son propre atelier d’impression en interne. 

    `
  },
  {
    title: 'MA MARQUE ET MES PRODUITS',
    slug: 'ma-marque-et-mes-produits',
    preview: 'Est-il possible d’avoir notre propre nom de domaine lorsque l’on a une boutique sur wiltee.com ?',
    text: `
### Est-il possible d’avoir notre propre nom de domaine lorsque l’on a une boutique sur wiltee.com?
Oui. Pour ce faire, merci de réserver votre nom de domaine sur OVH ou Gandhi puis de nous communiquer vos identifiants et mot de passe afin que l’on transmette ces éléments à notre équipe technique pour qu’il fasse le nécessaire. Délai : entre 3 et 10 jours.


### Proposez-vous la possibilité d'avoir une étiquette ou un marquage personnalisé avec mon logo au niveau du col intérieur des produits ?
Oui, nous proposons les 2 ! Nous pouvons soit imprimer votre marque au niveau du col, c’est ce que l’on appelle un neckprint, soit coudre votre étiquette au niveau col. D’ailleurs, nous fabriquons des étiquettes tissées. Pour toute demande de devis, veuillez vous adresser à bruno@wiltee.com


### Proposez-vous des packagings ? 
Non. Pour les packagings, vous pouvez commander chez [PackHelp](http://get.packhelp.com/raphaelmalka1392).
Attention, si vous commandez des packagings spécifiques et que vous souhaitez qu’on les utilise pour vos envois, les frais de livraison que l’on annonce vont varier. N’hésitez pas à nous demander pour avoir davantage d’informations.


### La livraison des produits se fait elle en marque blanche ? 
La livraison des produits peut se faire en marque blanche sur demande. 

    `
  },
  {
    title: 'DESIGN',
    slug: 'design',
    preview: 'Quelles sont les consignes à respecter en termes de design pour obtenir un marquage de qualité ?',
    text: `
### Quelles sont les consignes à respecter en termes de design pour obtenir un marquage de qualité ?  
Il est nécessaire d’uploader vos dessins en .PNG, 300 DPI, format colorimétrique RVB, recadré à la taille à laquelle vous souhaitez que celui-ci soit imprimé. Exemple : [lien](https://wiltee.com/eric-6cm-coeur.png)


### L’équipe Wiltee re-travaille-t-elle les designs de mauvaise qualité ? 
Non. Si vous importez un dessin de mauvaise qualité, vous en êtes 100% responsable. Wiltee imprime ce qui est importé. Néanmoins, avant d’importer vos dessins sur Wiltee, vous pouvez bien entendu nous les envoyer au préalable afin que l’on vérifie ensemble.

### Est-il possible d’uploader ses propres images dans les pages produits si l’on dispose d’une boutique sur wiltee.com ?
Oui. Pour ce faire, connectez-vous à votre espace client puis allez dans “campagnes” puis dans “modifier” puis “produits” puis “modifier les images” puis “ajouter une image”. Vous y êtes. Format recommandé : 530 X 630 pixels.

    `
  },
  {
    title: 'ECHANTILLONS',
    slug: 'echantillions',
    preview: 'Comment commander des échantillons ?',
    text: `
### Comment commander des échantillons ?
Écrivez à bruno@wiltee.com pour demander l’activation de votre espace échantillons. 
Une fois que la fonctionnalité est activée, connectez-vous à votre espace client puis dans votre menu latéral à gauche, cliquez sur “commandes” puis “nouvelle commande”. Ca y est, vous pouvez passer commande de vos produits au prix de production.

### Faites-vous des échantillons gratuits ?
Et non. Voir question ci-dessus.

    `
  },
  {
    title: 'PRODUCTION & LIVRAISON',
    slug: 'production-livraison',
    text: `
### Les prix de livraison indiqués sont-ils T.T.C (toutes taxes comprises) ? 
Oui.

+ Comment se déroule la communication du statut d'expédition et de livraison au client final ? 
2 étapes. Le client reçoit un premier email de confirmation de commande au moment du passage de sa commande. Le client reçoit un deuxième email confirmant l’expédition de sa commande avec le numéro de suivi.

+ A compter du passage de la commande, de la production jusqu’à la livraison, combien de temps faut-il compter pour que le client reçoive son colis ?
Nous expédions les commandes en moyenne en 7 jours ouvrés. En général, une fois la commande expédiée de nos ateliers, il faut compter entre 2 et 5 jours pour que votre client soit livré.

### Avec quels transporteurs travaillez-vous ?
Nous travaillons avec la poste et GLS.


### Quelle est notre politique de retour produit ?
Lorsque vous disposez d’une boutique sur Shopify et que vous utilisez Wiltee en tant qu’application, les retours sont 100% à votre charge. Autrement dit, si l’un de vos clients a passé commande, que la taille ne convient pas et que votre client souhaite échanger, c’est à vous de repasser commande sur Wiltee afin qu’on livre votre client une 2e fois de la taille souhaitée.


### Quel type d’enveloppe d’expédition utilisez-vous ?
Nous utilisons des enveloppes 100% compostables dans une démarche qui se veut plus respectueuse de l’environnement.

### Que faire en cas de livraison à mon client d’un produit jugé non conforme ? 
1e étape : demandez à votre client une photo nette du produit jugé non conforme. Écrire à bruno@wiltee.com en mentionnant votre numéro de commande, le problème, et en joignant la photo à votre email. Une fois cette information reçue, nous referons votre commande et renverrons le produit à votre client. Veuillez noter que toutes les plaintes concernant la qualité du produit doivent être signalées dans les 30 jours suivant l'achat afin d'être admissible à un nouvel envoi.


### Dans quels pays livrez-vous ?
Nous livrons partout dans le monde. Les délais sont bien entendu plus longs lorsque nous envoyons au Canada que lorsque nous envoyons en France.

### Le colis est indiqué “livré” par la Poste mais le client n’a rien reçu ? 
Le suivi du transporteur indique que le colis a été remis au destinataire, mais votre client vous affirme ne pas l’avoir reçu : Wiltee ne couvre pas l’expédition d’un nouveau colis.
Le suivi du transporteur fait foi : si le colis est marqué "livré" il n'y pas de recours possible.

Bien souvent le colis aura été déposé chez un voisin ou le client ne dispose pas d’une boite normalisée : dans ce cas il faut préconiser à votre client de se rendre au bureau de Poste le plus proche (si le transporteur est la Poste), muni de son numéro de suivi et d’une pièce d’identité afin de récupérer sa commande.
Nos colis sont conçus pour pouvoir être déposés dans la boite de vos clients. Si la boite n'est pas normalisée et que le colis ne peut pas y être déposé, il arrive également que le facteur / livreur le dépose au bureau de poste.
Si malgré tout le client vous dit ne pas avoir pu récupérer son colis, la décision est à prendre de votre coté : vous pouvez lui annoncer qu’une fois indiqué « livrée », vous n’êtes plus en mesure de lui envoyer une nouvelle commande ou alors vous pouvez décider de repasser une commande manuelle à vos frais.
    `
  },
  {
    title: 'FACTURATION & PAIEMENT',
    slug: 'facturation-paiement',
    preview: 'Comment récupérer mes bénéfices ?',
    text: `
### Comment récupérer mes bénéfices ?

Lorsque vous disposez d’une boutique sur Wiltee, Wiltee encaisse le montant total des ventes puis vous reverse les bénéfices de vos ventes dans un deuxième temps.
Pour récupérer ses bénéfices, veuillez vous connecter à votre espace client, puis aller dans l’onglet “paiement“. puis “enregsitrer son RIB”


### Où sont disponibles les factures ? 

    `
  },
  {
    title: 'CONNEXION À SHOPIFY',
    slug: 'connexion-a-shopify',
    preview: 'Comment lier Shopify et Wiltee ?',
    text: `
### Comment lier Shopify et Wiltee ?

#### Liaison Shopify Wiltee 

+ Créer une boutique sur Shopify 
>> Ne créer aucune page produit sur Shopify pour le moment.

+ Créer un compte sur Wiltee

+ Une fois connecté à Wiltee, se rendre dans l’onglet boutique dans le menu vertical à gauche.

+ Cliquer sur créer une boutique. 

+ Choisir boutique Shopify. 

+ Mettre l’URL de sa boutique Shopify

Cliquer sur le petit bonhomme en haut à droite.
Cliquer sur « moyens de paiement » puis ajouter un moyen de paiement
Remplir les informations relatives à sa carte bleue.
Cliquer sur« utiliser la carte pour les paiements automatiques» Cliquer sur enregistrer

#### Synchronisation des produits

Créer l’ensemble de vos produits sur Wiltee en suivant les étapes dans le module de personnalisation sans faire attention aux prix de vente puisque les prix de vente seront à déterminer sur votre Shopify par la suite.
>> Pour créer un produit, cliquez sur « créer un produit » en haut à droite dans votre espace client et suivez les étapes.

Une fois tous vos produits créés, cliquez sur boutique dans le menu vertical à gauche
Cliquez sur votre boutique avec le petit icone Shopify
Cliquez sur « exporter des produits » en haut à droite 
Sélectionner un premier produit que vous souhaitez exporter sur shopify puis cliquer sur le bouton bleu «exporter un produit»
Patienter quelques instants que le produit s'exporte. 
Rendez-vous ensuite directement au sein de votre backoffice Shopify et voyez dans votre onglet produit si le produit est bien apparu.

Si cela a marché, vous pouvez désormais exporter vos autres produits 3 par 3 .

Tous vos produits ont maintenant été exportés de Wiltee à Shopify.
Attention, ne jamais supprimer une page produit sur Shopify qui a été créé suite à l’exportation car cela cassera la liaison entre wiltee et la page produit.

Vous n’avez plus qu’à agencer votre Shopify comme vous le souhaitez :)


### Comment fonctionne le paiement entre Shopify et Wiltee ? 

Wiltee vous demande d’insérer votre carte bleue. Wiltee débite votre carte bleue automatiquement à chaque commande.
    `
  }
];